import karteClient from '../common/karte/user';

document.addEventListener('DOMContentLoaded', () => {
  const loggedInStaffId = document.getElementById('logged_in_staff_id') as HTMLInputElement;

  if (loggedInStaffId == null) {
    return;
  }

  const loggedInStaffEmail = document.getElementById('logged_in_staff_email') as HTMLInputElement;
  const loggedInOrganizationId = document.getElementById('logged_in_organization_id') as HTMLInputElement;
  const loggedInOrganizationName = document.getElementById('logged_in_organization_name') as HTMLInputElement;

  const sendUserToKarte = () => {
    const userId = loggedInStaffId.value;
    const email = loggedInStaffEmail.value;
    const organizationId = loggedInOrganizationId.value;
    const organizationName = loggedInOrganizationName.value;

    // 個人情報を送信
    karteClient.userIdentifyEvent({
      user_id: userId,
      email: email
    });

    // 個人情報ではない情報を送信
    karteClient.userAttributeEvent({
      organization_id: organizationId,
      organization_name: organizationName
    });

    // ログインイベント
    karteClient.userLoginEvent();
  }

  const initialize = () => {
    sendUserToKarte();
  }

  // 実行
  initialize();
});
